import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Search, ShoppingBag, Tag } from 'lucide-react';

const API = '/api';

export const BoutiquePage = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [prodRes, catRes] = await Promise.all([
          axios.get(`${API}/boutique/products`),
          axios.get(`${API}/boutique/categories`)
        ]);
        setProducts(prodRes.data);
        setCategories(catRes.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetchData();
  }, []);

  const filteredProducts = products.filter(p => {
    if (selectedCategory && p.category !== selectedCategory) return false;
    if (searchQuery && !p.name.toLowerCase().includes(searchQuery.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="min-h-screen bg-[#0a0a0f]">
      {/* Hero */}
      <div className="bg-gradient-to-b from-[#1a1a2e] to-[#0a0a0f] py-16 px-4 text-center">
        <h1 data-testid="boutique-title" className="text-4xl font-extrabold text-white mb-3">
          <ShoppingBag className="inline w-10 h-10 text-yellow-400 mr-3" />
          Boutique MAGAZEN
        </h1>
        <p className="text-gray-400 max-w-xl mx-auto">Pwodwi orijinal MAGAZEN LETA — 12,000 HTG valè chak mwa</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 pb-20">
        {/* Search & Filter */}
        <div className="flex flex-col sm:flex-row gap-3 mb-8">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
            <input
              data-testid="boutique-search"
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Chèche pwodwi..."
              className="w-full bg-[#12121a] border border-[#2d2d3a] text-white pl-11 pr-4 py-3 rounded-xl focus:outline-none focus:border-yellow-400/50"
            />
          </div>
          <div className="flex gap-2 flex-wrap">
            <button
              onClick={() => setSelectedCategory('')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${!selectedCategory ? 'bg-yellow-400 text-black' : 'bg-[#1a1a2e] text-gray-400 hover:text-white'}`}
            >
              Tout
            </button>
            {categories.map(cat => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all capitalize ${selectedCategory === cat ? 'bg-yellow-400 text-black' : 'bg-[#1a1a2e] text-gray-400 hover:text-white'}`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : filteredProducts.length === 0 ? (
          <div className="text-center py-20">
            <ShoppingBag className="w-20 h-20 text-gray-700 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">Pa gen pwodwi disponib pou kounye a</p>
            <p className="text-gray-600 text-sm mt-2">Pwodwi yo ap disponib byento!</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProducts.map(product => (
              <div key={product.product_id} data-testid={`product-${product.product_id}`} className="bg-[#12121a] rounded-xl border border-[#2d2d3a] overflow-hidden hover:border-yellow-400/30 transition-all group">
                {product.image_url ? (
                  <img src={product.image_url} alt={product.name} className="w-full h-48 object-cover" />
                ) : (
                  <div className="w-full h-48 bg-[#1a1a2e] flex items-center justify-center">
                    <ShoppingBag className="w-16 h-16 text-gray-700" />
                  </div>
                )}
                <div className="p-5">
                  <div className="flex items-start justify-between mb-2">
                    <h3 className="text-white font-semibold text-lg group-hover:text-yellow-400 transition-colors">{product.name}</h3>
                    {product.category && (
                      <span className="text-[10px] bg-yellow-400/10 text-yellow-400 px-2 py-0.5 rounded-full flex items-center gap-1">
                        <Tag className="w-3 h-3" />{product.category}
                      </span>
                    )}
                  </div>
                  <p className="text-gray-500 text-sm mb-4 line-clamp-2">{product.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-2xl font-bold text-yellow-400">{product.price?.toLocaleString()} HTG</span>
                    {product.stock > 0 && <span className="text-xs text-green-400">En stock</span>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
